<template>
  <b-sidebar id="sidebar" shadow lazy v-model="visible">
    <div class="sidebar-content content-container">
      <div class="banner-container">
        <img
          src="../../assets/images/gyra_banner/hyh_logo.png"
          alt="Gyra Banner"
          class="banner"
        />
      </div>

      <div class="navigation">
        <div
          class="nav-item-container"
          v-for="(navItem, i) in getNavItemsMobile"
          :key="i"
          @click="handleNavClick(navItem)"
        >
          <div class="nav-item-row">
            <div
              class="nav-item"
              :class="{
                selected: isCurrentNav(navItem),
                highlighted: isHighlightedNav(navItem)
              }"
            >
              {{ `header.${navItem.name}` | translate | uppercase }}
            </div>
            <i
              class="material-icons nav-arrow"
              v-if="navItem.hasSubNav"
              :class="{ open: isOpen(navItem) }"
            >
              expand_more
            </i>
          </div>
          <div class="nav-item-dropdown" v-if="isOpen(navItem)">
            <div
              v-for="(subNav, i) in subNavs"
              :key="i"
              @click="onSubNavClick(subNav)"
            >
              {{ `filter.type.${subNav}` | translate | capitalize }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import { sexNavigation } from "../../mixins";
import { categoryNavigation } from "../../mixins";
import { getPossibleFilterValues } from "../../services/api";
import { mapMutations } from "vuex";
import { productTypeNavigation } from "../../mixins/navigation/productTypeNavigation";

export default {
  name: "the-sidebar",
  mixins: [sexNavigation, categoryNavigation, productTypeNavigation],
  data() {
    return {
      searchTerm: null,
      openNavItem: null,
      subNavs: [],
      visible: null
    };
  },
  methods: {
    closeSidebar() {
      this.visible = false;
    },
    async applySearch() {},
    isOpen(navItem) {
      return this.openNavItem === navItem;
    },
    async handleNavClick(navItem) {
      if (navItem.hasSubNav) {
        await this.getSubNavs(navItem);
        this.setOpenOrToggle(navItem);
      } else {
        this.closeSidebar();
        this.navigateToCategory(navItem);
      }
    },
    setOpenOrToggle(navItem) {
      if (this.isOpen(navItem)) {
        this.openNavItem = null;
      } else {
        this.openNavItem = navItem;
      }
    },
    async getSubNavs(navItem) {
      let query = {
        sex: this.$route.params.sex
      };

      if (navItem.name === "sale") {
        query = { ...query, onSale: true };
      } else {
        query = { ...query, category: navItem.name };
      }

      const response = await getPossibleFilterValues("type", query);
      if (response.status === 200) {
        this.subNavs = response.data;
      } else {
        this.handleHttpError(response);
      }
    },
    onSubNavClick(subNavItem) {
      this.resetProducts();
      this.resetCommons();
      this.setSubNavItemWithFilter(subNavItem);
      this.navigateToCategory(this.openNavItem);
      this.closeSidebar();
    },
    ...mapMutations({
      setSubNavItem: "navigation/setCurrentSubNavItem",
      resetProducts: "overview/reset",
      resetCommons: "filters/resetCommons"
    })
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";

.banner {
  width: 5rem;
}

.banner-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.navigation {
  width: 100%;
  margin-top: 2rem;
}

.nav-item-container {
  display: flex;
  flex-direction: column;
}

.nav-item-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem 0;
}

.nav-item {
  cursor: pointer;
  &.selected {
    font-weight: bold;
  }

  &-dropdown {
    div {
      margin-left: 1.25rem;
    }
  }
}

.nav-arrow {
  transition: transform 0.25s ease-in-out;

  &.open {
    transform: rotate(180deg);
  }
}
</style>

<style lang="scss">
.b-sidebar {
  width: 414px;

  .close {
    box-shadow: none;
  }
}
</style>
